module.exports = __webpack_public_path__ + "static/media/DoneBlack.ceb4dbd9.svg";